import { render, staticRenderFns } from "./permit-dialog.vue?vue&type=template&id=4e9b38d3&"
import script from "./permit-dialog.vue?vue&type=script&lang=js&"
export * from "./permit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports